import clsx from 'clsx';
import { AText, Box, Button, Notification } from '@alf/uikit';
import { useGeneralRoutes, useOtherSettings } from '@namespace/cms';
import { useIsNavMenuVisible } from '@namespace/common';
import { useDeviceStore } from '@namespace/device';
import { LocalizedLink, useI18n } from '@namespace/i18n';
import useBetSlipVisible from '../../hooks/useBetSlipVisible';

import styles from './index.module.css';

const MandatoryDepositLimitToast = ({ onClose }) => {
  const { t } = useI18n();
  const { mandatoryLimit, responsibleGambling } = useGeneralRoutes();
  const { isMobile } = useDeviceStore();
  const isBetSlipVisible = useBetSlipVisible();
  const navMenuVisible = useIsNavMenuVisible();
  const { isVerificationBeforeLimitFlow = false } = useOtherSettings();
  const buttonLink = isVerificationBeforeLimitFlow
    ? responsibleGambling
    : mandatoryLimit;

  if (isMobile && isBetSlipVisible) {
    return null;
  }

  const message = (
    <Box align="center" justify="center" gap="m" className={styles.wrapper}>
      <AText size="l" className={styles.text}>
        {t('web.notification.responsiblegambling.depositlimit.message')}
      </AText>

      <Button
        {...(isVerificationBeforeLimitFlow ? { onClick: onClose } : {})}
        size="s"
        actionType="color4"
        intent="secondary"
        className={styles.link}
        component={LocalizedLink}
        to={buttonLink}
      >
        {t('web.notification.responsiblegambling.depositlimit.link')}
      </Button>
    </Box>
  );

  return (
    <Notification
      {...(isVerificationBeforeLimitFlow ? { onClose } : {})}
      message={message}
      className={clsx([
        isVerificationBeforeLimitFlow ? styles.general : styles.notification,
        navMenuVisible && styles.navMenuEnabled
      ])}
    />
  );
};

export default MandatoryDepositLimitToast;
